export default "__VITE_ASSET__CYLmAx$a__"